const TOKEN_KEY = "ACCESS_XPOST";
const COMPANY_KEY = "COMPANY_XPOST";
const REFRESH_TOKEN_KEY = "refresh_token";
const USER_LOGON = "user_logon";

const TokenService = {
  getToken() {
    return localStorage.getItem(TOKEN_KEY);
  },
  getCompany() {
    return localStorage.getItem(COMPANY_KEY);
  },
  saveToken(accessToken) {
    localStorage.setItem(TOKEN_KEY, accessToken);
  },
  saveCompany(companyDb) {
    localStorage.setItem(COMPANY_KEY, companyDb);
  },

  removeToken() {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(COMPANY_KEY);
    localStorage.removeItem(USER_LOGON);
  },

  getRefreshToken() {
    return localStorage.getItem(REFRESH_TOKEN_KEY);
  },

  saveRefreshToken(refreshToken) {
    localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken);
  },

  removeRefreshToken() {
    localStorage.removeItem(REFRESH_TOKEN_KEY);
  },

  saveUserLogon(userLogon) {
    localStorage.setItem(USER_LOGON, userLogon);
  },
  getUserLogon() {
    return localStorage.getItem(USER_LOGON);
  },
};

export { TokenService };
